import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { map } from 'rxjs/operators';
import { AreaModel } from '../models/area.model';

const base_url = environment.base_url;

@Injectable({
  providedIn: 'root'
})
export class AreaService {

  constructor( private http: HttpClient ) { }


get token(): string {
  return localStorage.getItem('token') || '';
}

get headers() {
 return {
   headers: {
    'x-token': this.token
   }
};
}

cargarAreasPaginacion( pagina: number = 0) {
  const url = `${ base_url }/areas/paginacion?pagina=` + pagina;
  return this.http.get( url, this.headers)
                  .pipe(
                    map( (resp: { ok: boolean, areas: AreaModel[] }) => resp.areas )
                  );

  }
  cargarAreas() {
  const url = `${ base_url }/areas`;
  return this.http.get( url, this.headers)
                  .pipe(
                    map( (resp: { ok: boolean, areas: AreaModel[] }) => resp.areas )
                  );
  }
  crearArea( name: string ) {
  const url = `${ base_url }/areas`;
  return this.http.post( url, { name }, this.headers);
  }
  actualizarArea( _id: string, area: AreaModel ) {
  const url = `${ base_url }/areas/${ _id }`;
  return this.http.put( url, { area }, this.headers);
  }
  eliminaSubArea( _id: string, area: AreaModel ) {
  const url = `${ base_url }/areas/deletesubarea/${ _id }`;
  return this.http.put( url, { area }, this.headers);
  }
  borrarArea( _id: string ) {
  const url = `${ base_url }/areas/${ _id }`;
  return this.http.delete( url, this.headers);
  }

}
